import { Icon } from "@iconify/react";
import React from "react";

const UnitCountFour = ({
  todayEvents,
  newEvents,
  acceptedEvents,
  todayUsers,
  totalUsers,
}) => {
  const fields = [
    {
      title: "Today Events",
      value: todayEvents,
      icon: "mdi:calendar-today",        // matches today's events
      bgColor: "bg-primary-600",
      info: "Total events created in system",
    },
    {
      title: "New Events",
      value: newEvents,
      icon: "mdi:calendar-plus",         // adding new events
      bgColor: "bg-success-main",
      info: "Events created recently",
    },
    {
      title: "Accepted Events",
      value: acceptedEvents,
      icon: "mdi:calendar-check",        // accepted/completed events
      bgColor: "bg-warning",
      info: "Events already expired",
    },
    {
      title: "Total Users",
      value: totalUsers,
      icon: "mdi:account-group",         // total users
      bgColor: "bg-red",
      info: "Total registered users",
    },
    {
      title: "New Users",
      value: todayUsers,
      icon: "mdi:account-plus",          // new users today
      bgColor: "bg-red",
      info: "Users registered today",
    },
  ];


  return (
    <div className="col-12">
      <div className="row gy-4">
        {fields.map((field, index) => (
          <div key={index} className="col-xxl-3 col-sm-6">
            <div
              className={`card px-24 py-16 shadow-none radius-8 border h-100 bg-gradient-start-${index + 1
                }`}
            >
              <div className="card-body p-0">
                <div className="d-flex align-items-center gap-3">
                  <div className="w-64-px h-64-px radius-16 bg-base-50 d-flex justify-content-center align-items-center">
                    <span
                      className={`w-40-px h-40-px ${field.bgColor} text-white d-flex justify-content-center align-items-center radius-8`}
                    >
                      <Icon icon={field.icon} className="icon" />
                    </span>
                  </div>

                  <div>
                    <span className="text-secondary-light text-md">
                      {field.title}
                    </span>

                    <h6 className="fw-semibold my-1">{field.value ?? 0}</h6>


                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UnitCountFour;